const Const = {
    DASHBOARD_SET_DASHBOARD_BUTTONS_STATE: 'DASHBOARD_SET_DASHBOARD_BUTTONS_STATE',
    DASHBOARD_FETCH_REQUEST_START: 'DASHBOARD_FETCH_REQUEST_START',
    DASHBOARD_SET_CLEAR_FILTERS: 'DASHBOARD_SET_CLEAR_FILTERS',
    DASHBOARD_REPORT_CSV_FETCH: 'DASHBOARD_REPORT_CSV_FETCH',
    DASHBOARD_CHANGE_FILTER: 'DASHBOARD_CHANGE_FILTER',
    DASHBOARD_FETCH: 'DASHBOARD_FETCH',
};

export default Const;